export * from '@fhs/routing/src/routes/v2/order';
export { default } from '@fhs/routing/src/routes/v2/order';
